import { FAST_TRACK } from '../../products';
import { getAirports, translateNparseJsonProp, getAirportsBySegments } from './productCardProps';
export const AvailabilityType = {
  PerBound: 0,
  PerSegment: 1
};
export const getAvailabilityList = function (bounds, list, type) {
  if (type === void 0) {
    type = AvailabilityType.PerBound;
  }
  if (!list) {
    return [];
  }
  const boundAirports = type === AvailabilityType.PerBound ? getAirports(bounds) : getAirportsBySegments(bounds);
  const filteredList = list.filter(item => item != null && item.available);
  if (filteredList.length === 0) {
    return [];
  }
  return boundAirports.map(airport => {
    const {
      code,
      name
    } = airport;
    const airportIndex = filteredList.findIndex(filterAirport => (filterAirport === null || filterAirport === void 0 ? void 0 : filterAirport.departureAirport) === (airport === null || airport === void 0 ? void 0 : airport.code) && filterAirport.boundIndex === airport.boundIndex);
    if (airportIndex !== -1) {
      return {
        ...filteredList[airportIndex],
        departureAirport: `${name} (${code})`,
        boundIndex: airport.boundIndex
      };
    }
    return {
      ...filteredList[0],
      departureAirport: `${name} (${code})`,
      available: false,
      boundIndex: airport.boundIndex
    };
  });
};
export const groupByAirportName = (items, numberOfTravelers) => items.reduce((acc, item) => {
  const existingItem = acc.find(x => x.airportName === item);
  if (existingItem) {
    existingItem.numberOfPass += numberOfTravelers;
  } else {
    acc.push({
      airportName: item,
      numberOfPass: numberOfTravelers
    });
  }
  return acc;
}, []);
export const getCartAvailability = (numberOfTravelers, cartTranslation, availabilityList) => {
  var _availabilityList$fil;
  const availableAirports = (_availabilityList$fil = availabilityList === null || availabilityList === void 0 ? void 0 : availabilityList.filter(airport => airport.available).map(airport => airport.departureAirport)) !== null && _availabilityList$fil !== void 0 ? _availabilityList$fil : [];
  const groupedAirportList = groupByAirportName(availableAirports, numberOfTravelers);
  return {
    hasAvailability: true,
    airportList: groupedAirportList,
    passLabel: cartTranslation
  };
};
export const withParseAvailability = (productId, t, availabilityTextkey) => {
  var _availabilityTranslat, _availabilityTranslat2;
  const availabilityTranslation = translateNparseJsonProp(t, availabilityTextkey);
  const cartPurchase = (_availabilityTranslat = availabilityTranslation === null || availabilityTranslation === void 0 || (_availabilityTranslat2 = availabilityTranslation.cart) === null || _availabilityTranslat2 === void 0 ? void 0 : _availabilityTranslat2.purchasedMessage) !== null && _availabilityTranslat !== void 0 ? _availabilityTranslat : 'Pass';
  const availabilityType = productId === FAST_TRACK.id ? AvailabilityType.PerBound : AvailabilityType.PerSegment;
  return (availability, bounds, numberOfTravelers) => getCartAvailability(numberOfTravelers, cartPurchase, getAvailabilityList(bounds, availability, availabilityType));
};
//# sourceMappingURL=availability.js.map